import React from "react";
import "./News.css";
function News() {
  return (
    <>
      <section className="news-main-sec">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h1>In The</h1>
              <h2>News</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="news-section">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-5">
              <img src={require("../../Assets/img/forbes.png")} alt="" />
            </div>
            <div className="col-lg-7">
              <h1>
                Gaming Arcade Wins a Communicator Award for the Fourth
                Consecutive Year
              </h1>
              <div className="dates-col">
                <p>May 16, 2022</p>
                <h4>Forbes India (online)</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default News;
